export const TYPE_GEO = 'geo';
export const TYPE_ORG = 'org';

export const TAB_PLACES = 'places';
export const TAB_ORGANIZATIONS = 'organizations';
